var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMarker = function SvgMarker(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.12 15.17",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2E3744;}.cls-2{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "activos"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3008",
    className: "cls-2",
    d: "M0,.91H13.35V14.26H0V.91Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "filters-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.06,.64c3.84,0,6.94,3.11,6.94,6.94s-3.11,6.94-6.94,6.94S.12,11.42,.12,7.58C.12,3.75,3.23,.64,7.06,.64h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "marker"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.06,1.49C3.7,1.49,.97,4.23,.97,7.58s2.73,6.09,6.09,6.09,6.09-2.73,6.09-6.09S10.42,1.49,7.06,1.49m0-.85c3.84,0,6.94,3.11,6.94,6.94s-3.11,6.94-6.94,6.94S.12,11.42,.12,7.58,3.23,.64,7.06,.64Z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMarker);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "marker.a5d5e8977ca26ae4fb1d2849c2836c8d.svg";